// extracted by mini-css-extract-plugin
export default {"rosterConflictTable":"rosterConflictTable-R3GNz","reset":"reset-kbIyi","conflictStudentsContainer":"conflictStudentsContainer-YFHZo"};